/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * ICategoryPageContentBlock contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum categoryNamePlacement {
    top = 'top',
    middle = 'middle',
    bottom = 'bottom'
}

export const enum layoutOptionsImage {
    large = 'large',
    medium = 'medium',
    small = 'small'
}

export interface ICategoryPageContentBlockConfig extends Msdyn365.IModuleConfig {
    categoryInfo?: string;
    categoryImage?: Msdyn365.IImageData;
    categoryName?: string;
    categoryNamePlacement?: categoryNamePlacement;
    headerCustomClass?: string;
    imageCustomClass?: string;
    descriptionCustomClass?: string;
    layoutOptionsImage?: layoutOptionsImage;
    links?: ILinksData[];
}

export interface ICategoryPageContentBlockResources {
    resourceKey: string;
}

export interface ILinksData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
}

export interface ICategoryPageContentBlockProps<T> extends Msdyn365.IModule<T> {
    resources: ICategoryPageContentBlockResources;
    config: ICategoryPageContentBlockConfig;
}
